<script setup lang="ts">
import BasePage from '@/components/pages/BasePage/BasePage.vue';
import BasePageTitle from '@/components/pages/BasePage/BasePageTitle.vue';
import { useVeeForm } from '@/components/forms/useVeeForm';
import { api } from '@/api';
import { routenames } from '@/router/routenames';
import ProtocolForm from './components/ProtocolForm.vue';
import { useLoading } from '@/utils/useLoading';
import { onMounted } from 'vue';
import PtwBackButton from '@/components/buttons/PtwBackButton.vue';
import BasePageStatus from '@/components/pages/BasePage/BasePageStatus.vue';
import { ProtocolDto } from '@/api/generator';
import { entityNotFoundErrorHandler } from '@/errorHandling';
import { useRouter } from 'vue-router';

export interface ProtocolDetailsViewProps {
  id: string;
}

const props = defineProps<ProtocolDetailsViewProps>();

const router = useRouter();

const { action: loadProtocol, loading } = useLoading(async () => {
  const { result } = await api.protocolsApi.getProtocol({ id: props.id }, [
    entityNotFoundErrorHandler(router),
  ]);

  if (result) {
    resetForm({ values: result });
  }
}, true);

const {
  form: { values, resetForm },
} = useVeeForm<ProtocolDto>({
  mode: 'details',
});

onMounted(loadProtocol);
</script>

<template>
  <BasePage :loading="loading">
    <template #title>
      <BasePageTitle :subtitle="$t('Protocol_one')" :title="values.name" :titleId="values.iuid" />
    </template>

    <template #status>
      <BasePageStatus :entity="values" />
    </template>

    <template #actions>
      <PtwBackButton :to="{ name: routenames.protocols.overview }" />
    </template>

    <ProtocolForm />
  </BasePage>
</template>
